import { KioskNavigation } from "components/navigation"
import { useAppUI } from "providers/ui"

export const AppNavigation = () => {
  const { sideMenus, matchedPath } = useAppUI()

  return <KioskNavigation value={matchedPath?.to} navigations={sideMenus} />
}
